<template>
  <div class="categoryItem">
    <div class="cate_item_header" v-if="type == 0 && cateItem.subSortName">
      <div class="cate_item_headtit">
        {{cateItem.subSortName}}
      </div>
    </div>
    <category_act-item v-if="type == 0 && cateItem" :cateItem="cateItem"
                       :markButtonCodeData="{buttontext: markButtonCodeData.buttontext ? (markButtonCodeData.buttontext + '-' + cateItem.subSortName) : cateItem.subSortName,
                       buttonCode: markButtonCodeData.buttonCode ? markButtonCodeData.buttonCode : ''}"></category_act-item>
    <van-row class="cate_item_list" v-if="(type == 0 && cateItem.subSortList && cateItem.subSortList.length) || (type == 1 && cateItem)">
      <van-col :span="widthspan" v-for="(item, index) in (type == 0 ? cateItem.subSortList : cateItem)" :key="type == 0 ? item.goodsSortId : item.seriesId">
        <div class="cate_item_item" @click="bannerClick(item, index, markButtonCodeData.buttonCode ? markButtonCodeData.buttonCode : '')">
          <img :src="type == 0 ? item.img_path : item.seriesImgPath">
          <p class="">{{type == 0 ? item.ad_title : item.seriesName}}</p>
          <div :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=1'" :username="'gh_5d4bb8e18b8b'" class="slide_cl_xcx" v-if="type == 0 && isWx && (item.ad_type == 7 || item.ad_type == 8)"></div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import category_actItem from './category_actItem'
import 'swiper/dist/css/swiper.min.css'
import {
  isWeixin,
  bannerClick
} from '../../assets/common/js/config'

export default {
  components: {
    category_actItem
  },
  props: {
    widthspan: Number,
    type: Number,
    cateItem: Object | Array,
    markButtonCodeData: Object | Array
  },
  name: 'categoryItem',
  data () {
    return {
      isWx: isWeixin() ? 1 : 0
    }
  },
  methods: {
    goProCate (sonId, name) {
      let buttontext = (this.markButtonCodeData && this.markButtonCodeData.buttontext) ? this.markButtonCodeData.buttontext : ''
      let buttonCode = (this.markButtonCodeData && this.markButtonCodeData.buttonCode) ? this.markButtonCodeData.buttonCode : ''
      this.$clickburiedPoint({
        data: {
          buttonCode: buttonCode,
          buttontext: buttontext ? (buttontext + '-' + this.cateItem.subSortName + '-' + name) : name
        }
      })
      if (this.type == 0) {
        let navlist = []
        this.cateItem.subSortList.map(item => {
          navlist.push({
            id: item.goodsSortId,
            name: item.sortName
          })
        })
        this.$store.commit('CATEGORY_NAV', JSON.stringify(navlist))
      } else {
        let navlist = []
        this.cateItem.map(item => {
          navlist.push({
            id: item.seriesId,
            name: item.seriesName
          })
        })
        this.$store.commit('CATEGORY_NAV', JSON.stringify(navlist))
      }
      this.$store.commit('CATEGORY_ID', '')
      this.$store.commit('CATEGORY_SONID', sonId)
      this.$router.push({
        path: '/productCategory',
        query: {
          title: encodeURIComponent(this.type == 0 ? this.cateItem.subSortName : '系列')
        }
      })

    },
    bannerClick: function (items, index, flowArea) {
      if (this.type == 0) {
        bannerClick(items, index, flowArea, this, () => {
          this.dataCollection(items, index, flowArea)
        }, this.markButtonCodeData.buttonCode ? this.markButtonCodeData.buttonCode : '',
          {
            point: {
              buttontext: this.markButtonCodeData.buttontext
                ? (this.markButtonCodeData.buttontext + (this.cateItem.subSortName ? ('-' + this.cateItem.subSortName) : ''))
                : (this.cateItem.subSortName ? this.cateItem.subSortName : ''),
              buttonCode: this.markButtonCodeData.buttonCode ? this.markButtonCodeData.buttonCode : ''
            }
          })
      } else {
        this.goProCate(items.seriesId, items.seriesName)
      }
    },
    dataCollection (items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var:
          flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },
  }
}
</script>

<style scoped lang="scss">
.categoryItem {
  margin-top: 0;
  margin-bottom: 0.17rem;
  background: #fff;
  border-radius: .04rem;
  .cate_item_header {
    height: .21rem;
    margin-bottom: .15rem;
    margin-left: 4%;
    .cate_item_headtit {
      float: left;
      width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: .15rem;
      color: #292929;
      font-weight: 500;
    }
  }
  .cate_item_list {
    margin: 0 0.11rem 0.03rem;
    .cate_item_item {
      width: 0.74rem;
      color: #444444;
      font-size: .13rem;
      margin-bottom: 0.14rem;
      position: relative;
      >p {
        text-align: center;
        white-space: nowrap;
        margin-top: 0.08rem;
      }
      >img {
        width: 0.74rem;
        height: 0.74rem;
        margin: 0 auto;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/category/categoryItem.vue